export function formatCurrencyWithSymbol(
  value: number | string | null | undefined,
  currency: string,
): string {
  if (value === null || value === undefined) return "-";

  const numericValue = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(numericValue)) {
    return "-";
  }

  const isUSD = currency === "USD";
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: currency || "ARS",
    minimumFractionDigits: isUSD ? 4 : 2,
    maximumFractionDigits: isUSD ? 4 : 2,
  }).format(numericValue);
}
